import imgNointernetconnection from '@assets/web-v3-images/nointernetconnectionInline.js';
import imgNotLowestUnique from '@assets/web-v3-images/not-lowest-unique.png';
import imgSomethingWentWrong from '@assets/web-v3-images/somethingWentWrongInline.js';
import imgSomethingWentWrong1 from '@assets/web-v3-images/somethingWentWrong1Inline.js';
import { Text } from '@radix-ui/themes';
import Buttons from '../Buttons';
import PopupFrame from '.';
import { useTranslation } from 'react-i18next';

const Texts = ({ text = 'Text demo test' }) => {
	return (
		<Text as='p' className='font-medium text-[15px] sm:text-[15px] md:text-[18px] lg:text-[18px] xl:text-[18px] text-[#A15C07] text-center py-3'>{text}</Text>
	)
}

const Images = ({ img, classNameImage }) => {
	return <img src={img} alt="img-no-internet-connection" className={`w-[100%] h-full ${classNameImage}`} />
}

// ----------UI-----------------
const NoInternetConnection = ({ handleClick = () => { }, textBtn = 'Test', img, text, classNameImage }) => {
	return (
		<div>
			<Images img={img} classNameImage={classNameImage} />
			<Texts text={text} />
			<Buttons handleClick={handleClick} textBtn={textBtn} classItem="!my-0"/>
		</div>
	)
}

export default function StateView({
	open, onOpenChange, handleClick, title = 'Title', type = '1'
}) {
	const { t } = useTranslation()
	// thêm type để lấy UI cần dùng 1,2,3,4
	let content = null;
	switch (type) {
		case "1":
			content = (
				<>
					{/* POPUP no internet connection */}
					< NoInternetConnection
						handleClick={handleClick}
						img={imgNointernetconnection}
						textBtn={t('retry')}
						text={t('please_check_your_internet_connection_and_try_again')}
					/>
				</>
			);
			break;
		case "2":
			content = (
				<>
					{/*POPUP something went wrong */}
					<NoInternetConnection
						handleClick={handleClick}
						img={imgSomethingWentWrong}
						textBtn={t('retry')}
						text={<>{t('this_service_is_temporarily_unavailable')}<br />{t('please_try_again_later')}</>}
					/>
				</>
			);
			break;
		case "3":
			content = (
				<>
					{/*POPUP Not Lowest Unique */}
					<NoInternetConnection
						handleClick={handleClick}
						img={imgNotLowestUnique}
						textBtn='Try Again'
						text='Your price is either a duplicate or not the lowest yet. Try another number!'
					/>
				</>
			);
			break;
		case "4":
			content = (
				<>
					{/*POPUP Not Lowest Unique ERROR */}
					<NoInternetConnection
						handleClick={handleClick}
						img={imgSomethingWentWrong1}
						textBtn={t('refresh')}
						text={t('the_request_took_too_long_please_try_again')}
						classNameImage='relative left-[10%]'
					/>
				</>
			);
			break;
		default:
			content = null;
	}

	return (
		<PopupFrame
			open={open}
			onOpenChange={onOpenChange}
			title={title}
		>
			<div className="w-full px-[8%] sm:px-[18%] mt-5">
				{content}
			</div>
		</PopupFrame>
	)
}
